(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9852],{

/***/ 42694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51649);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65447);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95286);
/* harmony import */ var _SidebarCMS_SidebarCMS__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21054);
/* harmony import */ var _LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50452);
/* harmony import */ var _LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








function LayoutDynamicSingle(_ref) {
  var data = _ref.data,
      categories = _ref.categories,
      appLinks = _ref.appLinks,
      categoryTitle = _ref.categoryTitle,
      contentName = _ref.contentName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("section", {
    className: (_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: (_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().row),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().column),
          children: data.data.map(function (dataContent) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card),
              children: [dataContent.fields.cover_image !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
                  className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().img),
                  src: dataContent.fields.cover_image.path,
                  alt: "Card cap"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().body),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
                  className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                  children: dataContent.title
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().meta),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                    className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tags),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                      className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tagsInfo),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_5__/* .IoMdCalendar */ .i95, {
                          className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().calendarIcon),
                          alt: "\u03B5\u03B9\u03BA\u03BF\u03BD\u03AF\u03B4\u03B9\u03BF \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                        children: (0,_utils_dayjs__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(dataContent.ct, 'DD MMMM, YYYY')
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                  dangerouslySetInnerHTML: {
                    __html: dataContent.fields.content
                  }
                })]
              })]
            }, dataContent.uuid);
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_LayoutDynamic_module_scss__WEBPACK_IMPORTED_MODULE_4___default().aside),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_SidebarCMS_SidebarCMS__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            categories: categories,
            appLinks: appLinks,
            contentName: contentName,
            categoryTitle: categoryTitle,
            isSingleNews: true
          })
        })]
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (LayoutDynamicSingle);

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 84859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Contest; }
/* harmony export */ });
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28833);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92536);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31875);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3266);
/* harmony import */ var _components_LayoutDynamic_LayoutDynamicSingle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42694);
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86894);
/* harmony import */ var _components_Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36593);
/* harmony import */ var _utils_getBreadcrumb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);











var __N_SSG = true;
function Contest(_ref) {
  var contest = _ref.contest,
      categories = _ref.categories,
      navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      appLinks = _ref.appLinks,
      slug = _ref.slug,
      meta = _ref.meta;
  var breadcrumbData = (0,_utils_getBreadcrumb__WEBPACK_IMPORTED_MODULE_6__/* .getBreadcrumbTwoStep */ .xk)(slug);
  var breadcrumb = (0,_utils_getBreadcrumb__WEBPACK_IMPORTED_MODULE_6__/* .createBreadcrumbJson */ .El)(breadcrumbData);

  if (!contest) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      meta: meta
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      title: "\u0394\u03B9\u03B1\u03B3\u03C9\u03BD\u03B9\u03C3\u03BC\u03BF\u03AF"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_LayoutDynamic_LayoutDynamicSingle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      data: contest,
      appLinks: appLinks,
      categories: categories,
      contentName: "diagwnismoi"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 65269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ getBreadcrumbValidation; },
/* harmony export */   "El": function() { return /* binding */ createBreadcrumbJson; },
/* harmony export */   "aY": function() { return /* binding */ getBreadcrumbStepProduct; },
/* harmony export */   "xk": function() { return /* binding */ getBreadcrumbTwoStep; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

function createBreadcrumbJson(list) {
  var breadcrumb = list.map(function (value, index) {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: value.name,
      item: value.url
    };
  });
  var json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb
  };
  return json;
}
function getBreadcrumbStepProduct(slug, index) {
  var step = slug.slice(0, index + 1).join('/');

  if (index === slug.length - 1) {
    return {
      url: "".concat("https://kritikos-sm.gr", "/products/").concat(step, "/"),
      name: slug[index].split('-')[0]
    };
  }

  return {
    url: "".concat("https://kritikos-sm.gr", "/categories/").concat(step, "/"),
    name: slug[index]
  };
}
function getBreadcrumbValidation(data) {
  if (data.length === 4) {
    return [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(0, 2)), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(3)));
  }

  return data;
}
function getBreadcrumbTwoStep(link) {
  var firstStep = link.split('/')[0];
  return [{
    url: "".concat("https://kritikos-sm.gr", "/").concat(firstStep, "/"),
    name: firstStep
  }, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(link, "/"),
    name: link.split('/')[1]
  }];
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  createBreadcrumbJson: createBreadcrumbJson,
  getBreadcrumbStepProduct: getBreadcrumbStepProduct,
  getBreadcrumbTwoStep: getBreadcrumbTwoStep,
  getBreadcrumbValidation: getBreadcrumbValidation
});

/***/ }),

/***/ 34072:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diagwnismoi/[slug]",
      function () {
        return __webpack_require__(84859);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3253,3996,4843,9950,9067,9527,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(34072); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);